export default {
    formatOSSRSSDropdown: RSSOSSList => {
        return RSSOSSList.map(item => {
            const itemFormat = { ...item };
            const prefix = item.name.substring(0, 3);
            const prefixed = prefix === 'OSS' || prefix === 'RSS';
            itemFormat.baseName = item.name;
            if (!prefixed) {
                if (item.ossNumber) {
                    itemFormat.name = `OSS ${item.name}`;
                    itemFormat.type = 'OSS';
                } else {
                    itemFormat.name = `RSS ${item.name}`;
                    itemFormat.type = 'RSS';
                }
            } else {
                if (prefix === 'OSS') {
                    itemFormat.type = 'OSS';
                } else {
                    itemFormat.type = 'RSS';
                }
            }
            itemFormat.code = `${itemFormat.code}-${itemFormat.type}`;
            return itemFormat;
        }).sort((a, b) => (a.type < b.type ? 1 : -1));
    }
};



// WEBPACK FOOTER //
// ./src/helpers/search.js